import { ChangeDetectorRef, Component, Inject, Input, OnInit, HostListener, ElementRef, ViewChild, AfterViewInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CartModalComponent } from 'src/app/components/cartModal/cart-modal/cart-modal.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { CartWholesaleService } from 'src/app/services/cartWholesale/cart-wholesale.service';
import { CategoriesService } from 'src/app/services/categories/categories.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ProductsService } from 'src/app/services/products/products.service';
import { ShareService } from 'src/app/services/share/share.service';
import { StoresService } from 'src/app/services/stores/stores.service';
import { WholesaleService } from 'src/app/services/wholesale/wholesale.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';


import { FavoritosService } from 'src/app/services/favorites/favorites';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { sub } from 'date-fns';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  //@ViewChild('siDesbordaContent') siDesbordaContent: ElementRef;
  phoneNumber: number | any
  api_whatsapp:string = 'https://api.whatsapp.com/send?'
  msg:string = '¡Hola! Quisiera conversar con una asesora'
  id_store_current : string = ''
  categories:any[] = []
  cartCount = 0
  cartTotal:any = 0
  isAuth:boolean = false
  slug:string = ''
  logo:string = ''
  private debounceTimer?: NodeJS.Timeout
  searchTerm:string = ''
  text:string = ''
  list:any[] = []
  default_photo: string = "https://puu.sh/ImNRs/0ab1b352dc.png";
  show:boolean = false
  searchReady:boolean = false
  //header variable
  headerType:string = ''
  menuAbierto:boolean = false
  //saber si desborda el contenedor
  //desborda:boolean


  productsFavorites:any[] = []
  openFav:boolean = false
  categoryOpen:any = {}

  isHomePage: boolean = true;

  public subscriber: Subscription;

  

  categories_float:any[] = []


	percentageSaveSubs: any = 15;
  isSubscription:boolean  = false


  constructor(
    @Inject(DOCUMENT) private document: Document,
    private modalService: ModalService<CartModalComponent>,
    private categoryService: CategoriesService,
    private cartService: CartService,
    private auth: AuthService,
    public router: Router,
    private route: ActivatedRoute,
    private cartWholesale: CartWholesaleService,
    private wholesale: WholesaleService,
    private shareservice: ShareService,
    private productService: ProductsService,
    private stores: StoresService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private favoritosService: FavoritosService,
		private checkoutService: CheckoutService,
    @Inject(PLATFORM_ID) private platformID,
    ) { 
      router.events.subscribe((val) => {
        if(val instanceof NavigationEnd){
          this.checkAuth()
          this.checkIfHomePage()
        }
       });   
      this.getFavorites()
  }

  checkIfHomePage(): void {
    const currentUrl = this.router.url;
    this.isHomePage = currentUrl === '/rednumbers';
  }
  ngOnInit() {

    this.subscriber = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      //al Navegar cierro el category open
        this.categoryOpen = {}
    });

  }

  
  redirectCollection(slug){
    this.router.navigate([`/${this.id_store_current}/categories/${slug}`])
  }



  ngOnDestroy () {
    this.subscriber?.unsubscribe();
  }



  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.menu-container');
    this.categoryOpen.show = clickedInside != null && clickedInside != undefined
    this.show = clickedInside != null && clickedInside != undefined
  }
  
  @HostListener('window:resize', ['$event'])
  onResize($event) {
    // this.getCtg();
  }


  getFavorites() {
    this.favoritosService.getProductFavorites().subscribe(list => {
        this.productsFavorites = list
    })
  }


  removeFromFavorite(producto){
    this.favoritosService.setProductFavorites(producto)
  }


  setVerctg(){
    this.wholesale.setVerCatalogo(false)
  }

  toggleCtg(category){
    this.categories.map(catg => {
      if(category.id === catg.id){
        catg.show = !catg.show
        this.categoryOpen = catg
      }
      else{
        catg.show = false
      }
      return catg
    })
  }
  
  getConfigStore(){
    this.stores.getAllConfig()
    .subscribe((config:any[]) => {
      config.map(({name, value}) => {
        name === 'header-text' && (this.text = value)
        name === 'header' && (this.headerType = value)
        if (name === 'subscribe-and-save') {
					this.percentageSaveSubs = JSON.parse(value);
				}
      })
    })
  }

  checkAuth(){
    this.getConfigStore()
    this.getId()
    this.getLogo()
    this.checkSlug()
  }



  getLogo(){
    this.stores.getLogo()
    .subscribe(logo => {
      this.logo = logo
    })
  }

  getId(){
    this.stores.getStoreId()
    .subscribe(async id => {
      if(id !== null && id !== "null"){
        this.id_store_current = id

        await this.getCtg()
        this.getItemsCart()
        this.getTotalCart()
      }
    })
  }

  checkSlug(){
    this.shareservice.getSlug().subscribe( (slug:string) =>  {
      this.router.url.includes('cart') && slug && this.getShare(slug)
    })
  }

  getShare(slug:string){
    this.shareservice.getShareByUserSlug(slug)
    .then(res => {
      this.isAuth && this.logout()
      let data = JSON.parse(res.data.json)
      let dataTransform = JSON.parse(data)
      const {type_sub_cart} = dataTransform
      this.isSubscription = type_sub_cart
      let products:any[] = dataTransform.products
      this.cartService.clear()
      if(isPlatformBrowser(this.platformID)){
        localStorage.setItem('user_reference', res.data.id_user)
        localStorage.setItem('id_share', slug)
      }
      if(type_sub_cart){
        this.checkoutService.setIsSub(type_sub_cart);
        this.cartService.setShowCheckout(type_sub_cart);
      }


      products = products.map(item => {
        if(type_sub_cart){
          item.product.variations[0].discountPrice = this.getPriceDiscount(item.product.variations[0], type_sub_cart);
          item.product.variations[0].isSubscription = type_sub_cart;
        }
        this.cartService.addItemTocart(item.product, item.product.variations[0], item.cantidad)
        // this.cartService.addItemTocart(item.product, item.product.variations[0], item.cantidad)
        return item
      })

      // console.log('productos',products)

      this.open()
      
    })
    .catch(err => {
      console.log(err)
    })
  }


	// getPriceDiscount(variant: object | any) {
	// 	let precio = variant.sale_price > 0 ? variant.sale_price : variant.price;
	// 	return (precio * (100 - this.percentageSaveSubs)) / 100;
	// }
   getPriceDiscount(variant:object | any, isSub:boolean = true){
    // let precio = variant.sale_price > 0 ? variant.sale_price : variant.price
    // return precio * (100 - this.percentageSaveSubs) / 100

    // BORRAR CUANDO TERMINE EL EVENTO REDNUMBERS
    let precio = variant.price
    if(isSub == false){
      precio = variant.sale_price > 0 ? variant.sale_price : variant.price
    }
    return precio * (100 - this.percentageSaveSubs) / 100

  }


  getCtg():Promise<any>{
    return new Promise( (resolve,reject) => {
      this.categoryService.getList(this.id_store_current)
      .then(res => {
        resolve( this.filterCategories2(res.data) )
      })
      .catch(err => {
        reject(err)
      })
    })
  }

  getItemsCart(){
    !this.isAuth ? this.cartService.getCartCount().subscribe(cart => this.cartCount = cart ) : this.cartWholesale.getCartCount().subscribe(cart => this.cartCount = cart )
  }
  getTotalCart(){
    this.cartService.getCartTotalObs().subscribe(total => this.cartTotal = total ) 
  }
  async open(): Promise<void> {
    if(this.cartCount == 0){
      return
    }
    const {CartModalComponent} = await import(
      '../../components/cartModal/cart-modal/cart-modal.component'
    );

    await this.modalService.open(CartModalComponent);
    this.modalService.nameComponent.next('CartModalComponent')
  }

  abrirMenu() {
  this.menuAbierto = !this.menuAbierto
  //this.cambiarTabindex();
  }

  hideMenu(){
    this.menuAbierto = false
  }

  logout(){
    this.auth.doLogout()
  } 

  async checkProducts(ctgs:any[]){
    this.categories = ctgs
    // let ctgProducts:any[]  = []
    // let slugsCat = ctgs.map(c => c.slug)
    // let products:any[] = []
    // const response = slugsCat.map( async slug =>  {
    //   return await this.productService.getListCategory(this.id_store_current, slug, 1, this.isAuth).then(res => res.data.data)
    // })
    // await Promise.all(response).then((promise:any[]) => promise.map(p => products.push(...p)))
    // products.forEach(p => p.categories.map(c => !(ctgProducts.includes(c.category.slug)) && ctgProducts.push(c.category.slug)))
  }

  redirectHeader(slug: string){
    this.router.navigate([`/${this.id_store_current}/${slug}`]);
  }

  redirectCtg(slug:string, ctg, sub:boolean){
    this.categoryOpen = {}
    !sub && this.router.navigate([`/${this.id_store_current}/categories/${slug}`])
    sub && this.router.navigate([`/${this.id_store_current}/categories/${ctg.slug}/${slug}`])
    // status ? this.router.navigate([`/home/wholesales/${slug}`]) : this.router.navigate([`/home/${slug}`])
  }
  // '/home/wholesales/{{category.slug}}' : '/home/{{category.slug}}'
    
  redirectwholesale(){
    this.document.location.href = 'http://oopsiepoopsiewholesale.com';
  }

  contactWhatsapp(){
    this.stores.AddClick(this.id_store_current, 'visit')
    .then(res => {
     if (typeof res.data === 'string' || res.data instanceof String){
      this.phoneNumber = res.data
      let url = `${this.api_whatsapp}phone=+${this.phoneNumber}&text=${this.msg}`
      let link = document.createElement("a")
      link.href = url
      link.target = "_blank"
      link.dispatchEvent(new MouseEvent("click"))
    }else{
      Swal.fire({icon: 'error',title: 'Oops...',text: 'Actualmente no hay asesoras disponibles'})
    }
    })
    .catch(err => {
      console.log(err)
    })
  }

  search(){
    this.searchReady = false
    this.productService.searchQuery.next(false)
    if(this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.searchProducts()
    }, 1000)
  }

  searchProducts(){
    if(this.searchTerm !== ''){
      this.spinner.show()
      this.productService.searchProducts(1, this.searchTerm, this.id_store_current)
      .then(res => {
        // console.log(res.data.data)
        this.list = res.data.data
        this.searchReady = true
        this.productService.searchQuery.next(true)
        this.productService.query.next(this.searchTerm)
        this.productService.products.next(res.data.data)
        this.spinner.hide()
      })
      .catch(err => {
        console.log(err)
        this.spinner.hide()
      })
    }else{
      this.productService.query.next('')
      this.productService.products.next([])
    }
  }

  processHTML(html: string) {
    // Create a temporary DOM element to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Add 'truncate' class to all <p> elements
    const paragraphs: NodeListOf<HTMLParagraphElement> = tempDiv.querySelectorAll('p');
    paragraphs.forEach((p: HTMLParagraphElement) => {
      p.classList.add('truncate');
    });

    // Return the sanitized HTML
    return this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML);
  }

  filterCategories2(categories:any[]){
    if(this.headerType === '1' || this.headerType === ''){
      this.headerType = '1'
      this.showCategories(categories)
    }
    else {
      //sumo los caracteres de las categorias *6.5 que sería el ancho de letra
      let caracteres = categories.map(cat => cat.name.length*6.5)
      let suma = 0
      //let widthContent = this.siDesbordaContent.nativeElement.clientWidth;
      let widthContent = document.documentElement.clientWidth;
      caracteres.forEach (function(numero){
        suma += numero;
      })
      //this.clearRepeat()

      if (suma > widthContent || widthContent <= 769) {
        this.headerType = '2'
        this.showCategories2(categories)
      } else {
        this.headerType = '1'
        this.showCategories(categories)
      }
    }
    
  }

  showCategories(categories:any[]){
    this.categories = []
      let hasSub = categories.some(ctg => ctg.sub_categories.length > 0)  
      if(hasSub){
        categories.map(ctg => {
          if(ctg.sub_categories.length > 0){
            let idSubs = ctg.sub_categories.map(sub => sub.id)
            categories.map(cat => {
              if(!idSubs.includes(cat.id)){
                this.categories.push(cat)
              }
            })
          }
        })
      }else{
        this.categories = categories
      }


      if(window &&  this.categories.length > 0){
        const category_slug = window.location?.href?.split('/').pop()
        this.categories_float = this.categories?.filter(ctg => ctg.slug != category_slug)
      }

    this.categories.map(ctg => ctg.show = false)

    this.categoryService.setCategoriesList(this.categories)

    this.clearRepeat()
    //console.log('header '+this.headerType, 'totalCategories '+this.categories)
  }
  showCategories2(categories:any[]){
    let totalCategories = []
    // if(item.slug == this.subCategorySearch){
    //   this.currentSubCategory = item
    // }

    categories.map(category => {
      if(category.sub_categories.length === 0){
        totalCategories.push(category)
      }else{
        category.sub_categories.map(sub => {
          sub.slug = `${category.slug}/${sub.slug}`
          totalCategories.push(sub)
        })
      }
    })
    this.categories = totalCategories
  }
  clearRepeat(){
    this.categories =  this.categories.reduce((unique, o) => {
      if(!unique.some(obj => obj.id === o.id)) {
        unique.push(o);
      }
      return unique;
    },[])
  }




  isCollection(text?: string){
    let keyWord = 'collection'
    return text.indexOf(keyWord) !== -1
  }


  


  getSlug(product){
    let nameProduct = product.name
      //si tiene variante tomo el name de la primer variante porque no tiene un name directamente
      if(product.variants?.length > 0 && product.name == null || product.name == undefined){
        nameProduct = product.variants[0].name
      }
      let slugName = this.getNameSlug(nameProduct)
      this.router.navigate([`/${this.id_store_current}/product/${slugName}`])
  }


  redirectSlugFavorite(product){
    let slugName = this.getNameSlug(product.nombre)
    this.router.navigate([`/${this.id_store_current}/product/${slugName}`])
  }

  getNameSlug(nombre){
   return nombre.replace(/-/g,'_') //reemplazo guion por _
      .replace(/\s-\s/g,'-_-') //reemplazo guion con espacio de cada lado por _
      .replace(/\s/g, '-') //reemplazo espacio en blanco por guion
      .replace(/\+/g,'¬') // reemplazo + por ¬ 
      .replace(/\//g,'\\') // reemplazo / por \
  }










/*
  filterCategories(categories:any[]){
    if(this.headerType === '1' || this.headerType === ''){
      this.categories = []
      let hasSub = categories.some(ctg => ctg.sub_categories.length > 0)  
      if(hasSub){
        categories.map(ctg => {
          if(ctg.sub_categories.length > 0){
            let idSubs = ctg.sub_categories.map(sub => sub.id)
            categories.map(cat => !idSubs.includes(cat.id) && (this.categories.push(cat)))
          }
        })
      }else{
        this.categories = categories
      }    
    }else{
      this.categories = categories
    }
    this.categories.map(ctg => ctg.show = false)
    this.clearRepeat()
    setTimeout(() => {
      if(this.headerType === '2') this.controlarDesbordamiento();  
    }, 2000);
  }

  clearRepeat(){
    this.categories =  this.categories.reduce((unique, o) => {
      if(!unique.some(obj => obj.id === o.id)) {
        unique.push(o);
      }
      return unique;
    },[])
  }

  @HostListener('window:resize', ['$event'])
  onResize($event) {
    if(this.headerType === '2') this.controlarDesbordamiento();
  }
  @HostListener("wheel", ["$event"])
  public onScroll(event: WheelEvent) {
    if(this.headerType === '2' && this.desborda == true) {this.siDesbordaContent.nativeElement.scrollLeft += event.deltaY;
    event.preventDefault();}
    else return;
  }

  controlarDesbordamiento() {
    let widthTotal = this.siDesbordaContent.nativeElement.scrollWidth;
    let widthContent = this.siDesbordaContent.nativeElement.clientWidth;
    if(widthTotal > widthContent){
      this.desborda=true;
    } else {this.desborda=false;}
  }
  */
}

